/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Button } from '@mui/material';
import { useForm, FormProvider, SubmitHandler } from 'react-hook-form';
import * as yup from 'yup';
import RHFFile from 'src/components/elements/File/RHFFile';
import { FileFormat } from 'src/components/elements/File';
import RHFInput from 'src/components/elements/Input/RHFInput';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import { AddDocumentPopupProps, UploadDocumentProps } from '../../types';

const validationSchema: yup.ObjectSchema<UploadDocumentProps> = yup.object().shape({
  attachment: yup.mixed<any>().required('Attachment is required'),
  fileName: yup.string().typeError('Please enter valid file name').required('File name is required'),
});

function DocumentAdd(props: AddDocumentPopupProps) {
  const { onUpload, close } = props;
  const methods = useForm<UploadDocumentProps>({
    defaultValues: {},
    resolver: useYupValidationResolver(validationSchema),
  });
  const { handleSubmit } = methods;

  const submitHandler: SubmitHandler<UploadDocumentProps> = (data: UploadDocumentProps) => {
    if (close) {
      close();
    }
    onUpload(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <div className="flex flex-col items-center">
          <div className="w-[90%]">
            <RHFFile
              control={methods.control}
              name="attachment"
              supportTypes={{ [FileFormat.PDF]: [], [FileFormat.JPG]: [], [FileFormat.PNG]: [] }}
              label="Attachment"
              minSize={1}
              maxSize={10000000}
            />
          </div>
          <div className="w-[90%] my-6">
            <RHFInput
              control={methods.control}
              name="fileName"
              label="File Name*"
            />
          </div>
          <div className="w-[90%] flex flex-row justify-end">
            <Button
              type="submit"
              variant="contained"
            >
              Upload
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default DocumentAdd;
